import { getAudioContext } from './sharedAudio';

/**
 * THE ACKNOWLEDGEMENT: a short, soft two-note blip made with WebAudio (no asset), played the moment a turn is sent so the
 * person knows they were heard before any word comes back (target under 300 ms). Quiet on purpose: 0.05 gain, 140 ms.
 * Reduced motion keeps it (it is sound, not movement). Voice mode's Mute silences it (the hook does not call this).
 * Returns the notes' total length in seconds (0 when there is no audio).
 */
export function playEarcon(ctx = getAudioContext()) {
  if (!ctx || typeof ctx.createOscillator !== 'function') return 0;
  try {
    const t0 = ctx.currentTime + 0.01;
    const gain = ctx.createGain();
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(0.05, t0 + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.14);
    const osc = ctx.createOscillator();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(660, t0);
    osc.frequency.setValueAtTime(880, t0 + 0.06);
    osc.connect(gain);
    osc.start(t0);
    osc.stop(t0 + 0.15);
    return 0.14;
  } catch (_) { return 0; }
}
